import { Container, Grid } from "@mui/material";
import AlarmGroups from "../logic/AlarmGroups";

export default function AlarmGroupPage() {
	return (
		<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={3}>

				{/* AlarmGroup */}
				<AlarmGroups />

			</Grid>
		</Container>
	);
}
